import { jsx as e } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import { memo as c, forwardRef as p } from "../../../../../external/preact/compat/dist/compat.module.js";
import h from "./CalendarGridDate.js";
import y from "./CalendarGridDayOfWeek.js";
/* empty css                  */
const _ = p(({ cursorRootProps: t, onlyCellsWithin: i, prepare: d, grid: r }, s) => /* @__PURE__ */ e("ol", { className: "adyen-pe-calendar", role: "none", ...t, children: r.map((a) => /* @__PURE__ */ e("li", { className: "adyen-pe-calendar__month", role: "none", children: [
  /* @__PURE__ */ e("div", { className: "adyen-pe-calendar__month-name", role: "none", children: /* @__PURE__ */ e("time", { dateTime: a.datetime, "aria-hidden": "true", children: a.label }) }),
  /* @__PURE__ */ e(
    "table",
    {
      role: "grid",
      "aria-multiselectable": !0,
      "aria-label": `${a.label} calendar`,
      className: "adyen-pe-calendar__grid",
      style: { "--adyen-pe-calendar-rowspan": r.rowspan },
      children: [
        /* @__PURE__ */ e("thead", { children: /* @__PURE__ */ e("tr", { className: "adyen-pe-calendar__row", children: r.weekdays.map((l, n) => /* @__PURE__ */ e(y, { grid: r, block: a, prepare: d, cell: n, ...l }, l.labels.long)) }) }),
        /* @__PURE__ */ e("tbody", { children: a.map((l, n) => /* @__PURE__ */ e("tr", { className: "adyen-pe-calendar__row", children: l.map((m, o) => /* @__PURE__ */ e(
          h,
          {
            ref: s,
            grid: r,
            block: a,
            prepare: d,
            cell: o,
            onlyCellsWithin: i,
            row: n,
            ...m
          },
          `${a.month}:${m.timestamp}`
        )) }, `${a.month}:${n}`)) })
      ]
    }
  )
] }, a.datetime)) })), C = c(_);
export {
  C as default
};
